import React, { useEffect, useRef, useState } from "react";
import styles from './how-it-works.module.scss'
import LayoutFull from '../layouts/layoutFull/LayoutFull';
import getPages from "../helpers/data/get/pages";
import SeoApiHandler from "../helpers/seo/SeoApiHandler";
import PageArticle, { preparePageArticle } from "../layouts/pages/article/PageArticle";
import { NAV_HOW_IT_WORKS } from "../settings/navigation";
import { cliError } from "../helpers/cli/colors";
import TextPageLayout from "../layouts/pages/article/TextPageLayout";
import Breadcrumb, { BreadcrumbLayer } from "../components/Breadcrumb";
import DraftHTML from "../components/draftEditor/export/DraftHTML";
import articleStyles from "../layouts/pages/article/articleStyles.module.scss";
import Page, { Block, Content } from "../layouts/Content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export async function getStaticProps() {

    const seo = await getPages(NAV_HOW_IT_WORKS);

    if (!seo?.custom?.hiwSlider?.length) {
        cliError('How it works steps are missing!')
        throw 'How it works steps are missing!'
    }

    const article = preparePageArticle({page: seo});

    if (!article?.page_content) {
        cliError('How it works main content is missing!')
        throw 'How it works main content is missing!'
    }

    return {
        props: {
            seo,
            article,
            hiwSlider: seo.custom.hiwSlider,
        },
    }
}

function scrollToAnchor(anchor, e, smooth, container, top) {

    if (!!e && !!e.stopPropagation) e.stopPropagation();
    if (!!e && !!e.preventDefault) e.preventDefault();

    const element = document.getElementById(anchor) || document.getElementsByClassName(anchor)[0];
    const layout = document.getElementById(container);

    if (!element) return false;
    const position = element.offsetTop;
    const windowPosition = layout.offsetTop;
    const elementStart = position - windowPosition - top;

    layout.scrollTo({
        top: elementStart,
        behavior: !!smooth ? "smooth" : 'instant'
    });

    return true
}

function HowItWorks({seo, article, hiwSlider}) {

    const sliderRef = useRef(null);
    const [currentSection, setCurrentSection] = useState(undefined);
    const [currentSections, setCurrentSections] = useState([]);

    const addWheelScrollFix = e => {
        if (e.deltaY !== 0) {
            sliderRef?.current?.scrollBy(0, e.deltaY);
        }
    };

    const handleNav = e => {
        const center = sliderRef?.current?.scrollY + sliderRef?.current?.innerHeight / 3;
        // const clear = sliderRef?.current?.scrollY < positions[0].top;
        // const current = positions.find(s => center > s.top && center < s.bottom)?.id;
        // if (clear && currentSection !== undefined) {
        //     setCurrentSection(undefined);
        // } else if (current && current !== currentSection) {
        //     setCurrentSection(current)
        // }

        let past = [];

        hiwSlider.map((s, i) => {
            const el = document.getElementById(`slide-${i + 1}`);
            if (el.getBoundingClientRect().top + document.documentElement.scrollTop - 70 <= 5) {
                past.push(i)
            }
        })

        setCurrentSections(past)
    };

    useEffect(() => {
        sliderRef?.current?.addEventListener('wheel', addWheelScrollFix, {passive: false, behavior: 'smooth'});
        sliderRef?.current?.addEventListener('scroll', handleNav, {passive: false, behavior: 'smooth'});
        setTimeout(() => document.body.style.overflow = 'hidden', 0)
        return () => {
            sliderRef?.current?.removeEventListener('wheel', addWheelScrollFix);
            sliderRef?.current?.removeEventListener('scroll', handleNav);
            setTimeout(() => document.body.style.overflow = 'auto', 0)
        }
    }, []);

    return (
        <LayoutFull>
            <SeoApiHandler data={seo}/>
            <div className={styles.nav}>
                <div className={styles.nav__main}>
                    <a
                        onClick={e => {
                            e.preventDefault();
                            scrollToAnchor('slide-main', e, true, 'slides-scroll-container', 70);
                        }}
                        aria-label='Main content'
                        rel='nofollow'
                    >
                        <FontAwesomeIcon icon={'home'} height='14px' width={'14px'}/>
                    </a>
                </div>
                {
                    hiwSlider.map((slide, index) => {
                        return (
                            <div
                                className={`${styles.nav__item}${currentSections.includes(index) ? ` ${styles['nav__item--scrolled']}` : ''}`}
                                key={index}
                            >
                                <a
                                    onClick={e => {
                                        e.preventDefault();
                                        scrollToAnchor(`slide-${index + 1}`, e, true, 'slides-scroll-container', 70);
                                    }}
                                    aria-label={`Slide ${index + 1}`}
                                    title={slide.title}
                                    rel='nofollow'
                                >
                                    {index + 1}
                                </a>
                            </div>
                        )
                    })
                }
            </div>
            <Page className={styles.tp}>
                <div className={styles.slider} ref={sliderRef} id='slides-scroll-container'>
                    <div className={styles.slide}>
                        <Block className={styles.breadcrumb}>
                            <Breadcrumb inverse>
                                <BreadcrumbLayer link='/' name='Home'/>
                                <BreadcrumbLayer name={article.title}/>
                            </Breadcrumb>
                        </Block>
                        <Block id={`slide-main`}>
                            <Content className={styles.title} noSection stretch>
                                <h1 className={styles.title__text}>{article.title}</h1>
                            </Content>
                            <Content className={styles.content} noSection style={{paddingBottom: '100px'}}>
                                <DraftHTML
                                    className={`content-editor ${articleStyles.article}`}
                                    content={article.page_content}
                                />
                            </Content>
                        </Block>
                    </div>
                    {
                        hiwSlider.map((slide, index) => {
                            return (
                                <Block
                                    id={`slide-${index + 1}`}
                                    className={styles.slide}
                                    style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                                    key={index}
                                >
                                    <Content
                                        style={{paddingTop: '20px'}}
                                        noSection
                                    >
                                        <h2 className={styles.slide__title}>
                                            {slide.title}
                                        </h2>
                                    </Content>
                                    <Content
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            paddingBottom: '100px'
                                        }}
                                        className={styles.content}
                                        noSection
                                    >
                                        <DraftHTML
                                            className={`content-editor ${articleStyles.article}`}
                                            content={slide.content}
                                        />
                                    </Content>
                                </Block>
                            )
                        })
                    }
                </div>
            </Page>
        </LayoutFull>
    );
}

export default HowItWorks